// French

export default {
  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `clôture le ${date}` : ''),
    },
    interview: {
      title: 'Répondre à l\'entretien vidéo',
      submit: 'Envoyer les réponses et terminer l\'entretien',
      continueLater: 'Reprendre ultérieurement',
      startInterview: 'Commencer l\'entretien',
      duplicateError: 'Vous avez déjà participé à cet entretien. Vous avez reçu un e-mail de l\'adresse invitations@recright.com contenant un lien qui peut être utilisé pour reprendre l\'entretien.',
      confirmSubmitHeader: 'Vous n\'avez pas répondu à toutes les questions de l\'entretien',
      confirmSubmitContent: 'Voulez-vous vraiment terminer l\'entretien ?',
      confirmSubmitContentWarning: 'Après cela, vous ne pourrez plus répondre aux questions manquantes.',
      submitInterviewHeader: 'Envoyez les réponses de votre entretien',
      submitInterviewContent: 'Êtes-vous sûr(e) de vouloir soumettre votre entretien?',
      confirmSubmitButton: 'Envoyer les réponses et terminer l\'entretien',
      preview: 'Vous pouvez prévisualiser les questions vidéo ici.',
      withdrawLink: 'Vous n\'êtes plus intéressé(e) par ce poste ? Vous pouvez retirer votre candidature ici.',
    },

    personalInterview: {
      title: 'Select time for an appointment',
      description: [
        'You have been invited to an appointment.',
        'Please select a time slot that suits you best.',
      ],
      position: 'Position:',
      location: 'Location:',
      time: 'Time:',
      timezoneNotice: [
        'Please keep in mind that the times are shown in your timezone.',
        'Your timezone appears to be:',
        'The appointment timezone is:',
      ],
      success: {
        title: 'Thank you',
        description: 'You have successfully scheduled a meeting',
        linkDescription: [
          'You can add the calendar invitation to your own calendar below.',
          'Or you can copy the link to your calendar app:',
        ],
        link: 'Add the calendar invitation to your calendar',
      },
    },

    interviewForm: {
      name: 'Nom',
      city: 'Ville',
      email: 'Courriel',
      phone: 'Numéro de téléphone',
      link: 'Lien',
      legendBasicInfo: 'Informations de base',
      placeholderName: 'Saisissez votre nom',
      placeholderEmail: 'Saisissez votre adresse email',
      placeholderPhone: 'Saisissez votre numéro de téléphone',
      placeholderCity: 'Saisissez votre ville de résidence actuelle',
      placeholderLink: 'Ajoutez un lien, par exemple votre profil LinkedIn.',
      legendAttachments: 'Pièces jointes',
      legendAdditionalFields: 'Informations supplémentaires',
      required: 'Les champs comportant un astérisque * sont obligatoires.',
    },

    sequencedInterview: {
      networkTest: {
        audio: 'Audio',
        video: 'Vidéo',
        yes: 'Oui',
        no: 'Non',
        supported: 'Pris en charge',
        quality: 'Qualité',
        header: 'Connexion réseau et test appareil',
        description: 'Nous allons à présent effectuer un test afin de s\'assurer que votre connexion réseau et matériel nécessaires pour passer l\'entretien (caméra et microphone) fonctionnent convenablement. Lorsque vous y êtes invité, veuillez autoriser le test à utiliser votre caméra ainsi que votre microphone, et vérifiez que votre caméra ne soit pas recouverte. Le test prend environ 30 secondes. Nous vous recommandons de parler lors du test du matériel.',
        inProgress: 'Test en cours...',
        networkTestResults: 'Résultats du test de connexion réseau',
        qualityTestResults: 'Résultats du test de la qualité',
        testPassedQuality: 'Test de qualité réussi',
        testFailedQuality: 'Échec du test de qualité',
        testPassedNetwork: 'Test réseau réussi',
        testFailedNetwork: 'Test de connexion réseau échoué',
        startTest: 'Commencer le test',
        startInterview: 'Débuter l\'entretien',
        testAgain: 'Procéder à un nouveau test',
        confirmWarning: 'Lorsque votre entretien vidéo démarre, la première question vous est automatiquement posée. Après avoir lu la question, vous passerez à la préparation.',
        confirmTitle: 'Vous êtes sur le point de débuter votre entretien',
        confirmText: 'Vous disposez d\'un court moment pour préparer votre réponse avant chaque question. Après vous être  préparé(e), vous disposez d\'un temps prédéfini pour répondre à la question. Veuillez noter que vous pouvez soumettre votre réponse dès que vous êtes prêt(e), même si le temps de réponse prédéfini n\'est pas totalement écoulé.',
        confirmText2: 'Lorsque vous avez soumis votre réponse, vous êtes redirigé vers la prochaine question jusqu\'à ce qu\'il n\'y en ait plus.',
        confirmText3:
          'Veuillez noter qu’après avoir enregistré votre réponse à une question, vous disposerez de 30 secondes pour la rectifier si cela est autorisé pour la question concernée. Si vous ne demandez pas à la rectifier dans ce délai de 30 secondes, votre réponse actuelle sera automatiquement transmise et vous serez redirigé(e) vers la question suivante.',
        goodLuck: 'Inspirez profondément, et tout ira bien. Bonne chance !',
        qualityRating: {
          excellent: 'Excellent',
          good: 'Bon',
          fair: 'Assez bien',
          poor: 'Faible',
          bad: 'Mauvais',
        },
      },
      questionAnswerView: {
        title: title => `Répondre à l'entretien ${title}`,
        question: 'Question',
        submitAndNext: 'Soumettre & Suivant',
        submitSuccess: 'Vidéo soumise avec succès !',
        skipText: 'Commencer l\'enregistrement',
        stop: 'Arrêter',
        submitAndFinish: 'Soumettre et terminer l\'entretien',
        retake: 'Nouvelle prise',
        take: 'Prise',
        takesLeft: 'Prises restantes',
        skipTextQuestion: 'Terminé ? Passer à la suite',
        retakeConfirmTitle: 'Êtes-vous sûr(e) de vouloir rectifier votre réponse pour cette question?',
        retakeConfirmSubmit: 'Oui, lancez la rectification',
        submitInfoForward: 'Envoi automatique de votre réponse actuelle et suite dans',
        submitInfoForward2: 'secondes',
        nonAnswerableText: 'Ce message ne nécessite pas de réponse. À la suite de ce message, vous passerez directement à la question suivante.',
        nonAnswerableVideo: 'Cette vidéo ne nécessite pas de réponse. À la suite de cette vidéo, vous passerez directement à la question suivante.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `Vous disposez de ${answerMinutes} minutes et ${answerSeconds} secondes pour répondre à la question.`,
      },
      publisher: {
        toNextQuestion: timer => `La question suivante s'affichera dans ${timer}`,
        recordingStarts: timer => `L'enregistrement débutera dans ${timer}`,
      },
      errors: {
        tooManyConnections: 'Connexion interrompue car vous êtes déjà connecté(e) dans un autre onglet ou une autre fenêtre.',
        unsupportedBrowser: 'Malheureusement, cette opération n\'est pas prise en charge par votre navigateur. Veuillez utiliser un navigateur différent.',
        networkError: 'Aucune connexion Internet.',
        reconnecting: 'La connexion a été interrompue. Tentative de reconnexion.',
        generalError: 'Un problème est survenu. Veuillez recharger la page et réessayer.',
        allowMediaDevicesError: 'Cette opération n\'a pas pu obtenir d\'appareils mobiles (caméra ou microphone). Veuillez vous assurer d\'avoir autorisé votre navigateur à utiliser votre caméra et votre microphone.',
        noAvailableDevicesError: 'Nous n\'avons pas pu détecter de caméra ni de microphone.',
        initPublisherError: 'L\'opération a échoué en raison d’une erreur. Assurez-vous d\'avoir autorisé le navigateur à utiliser votre appareil photo et votre microphone, et qu\'ils ne sont pas utilisés par une autre application et essayez à nouveau.',
      },
      browserInfo: {
        browserSupportTitle: 'Prise en charge du navigateur',
        supportedBrowsers: 'Ce test et cet entretien sont pris en charge par les dernières versions de Chrome, Firefox, Safari et Edge.',
        mobileSupported: 'Navigateurs pris en charge sur appareils portables',
        android: 'Android : Google Chrome (dernière version), Firefox (dernière version)',
        iOS: 'iOS : Safari (dernière version)',
        latestVersion: 'Veuillez vous assurer que vous utilisez la version la plus récente du navigateur. Cela garantira un fonctionnement optimal du processus.',
        freezeInstruction: 'Si l’enregistrement vidéo ne démarre pas ou que l’écran reste noir, veuillez rafraîchir la page.',
        unsupportedOnIos: 'Il semblerait que vous utilisez un navigateur non pris en charge sur iOS. Veuillez utiliser Safari.',
        ieUnsupported: 'Il semblerait que vous utilisez Internet Explorer. Malheureusement, Internet Explorer n\'est pas pris en charge pour ce test ou cet entretien. Veuillez utiliser un navigateur différent.',
        qualityTestNotSupported: 'Malheureusement, le test du matériel n\'est pas pris en charge par votre navigateur actuel. Vous pouvez procéder à l\'entretien sans contrôler la qualité audio et vidéo, ou utilisez un navigateur différent.',
      },
      reconnectSuccess: 'Reconnexion réussie !',
      continue: 'Poursuivre',
    },

    withdraw: {
      title: 'Vous n\'êtes plus intéressé(e) par ce poste ?',
      description: 'Retirer votre candidature.',
      buttonText: 'Retirer sa candidature',
      thankYouTitle: 'Merci !',
      thankYouText: 'Les recruteurs savent désormais que vous n\'êtes plus intéressé(e) par ce poste.',
      confirm: 'Êtes-vous certain(e) de vouloir retirer votre candidature ? Après l\'avoir retirée, vous ne pourrez plus soumettre votre candidature pour cet entretien ou tout autre entretien lié à ce poste.',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: 'Envoyer',
      continue: 'Continuer',
      supportCenter: 'Recright Help Center',
      thankYou:
        'Merci pour votre réponse vidéo ! Nous vous contacterons très prochainement !',
    },

    supportLink: 'support@recright.com',

    finished: {
      title: 'Merci d\'avoir pris part à l\'entretien !',
      reopenDescription: 'Si vous avez quitté cet entretien par erreur, il vous suffit de cliquer sur le bouton ci-dessous pour le réouvrir !',
      reopenButtonText: 'Réouvrir l\'entretien',
      description1: 'Parfait, vous avez répondu à toutes les questions et vos réponses ont été envoyées au destinataire.',
      descriptionsupport: mailto => `Si vous avez mis fin à cet entretien par erreur, veuillez contacter notre service client ${mailto} pour pouvoir y accéder à nouveau.`,
      descriptionfeedback: 'Votre avis nous intéresse ! Quelles sont vos impressions après avoir passé un entretien vidéo ? Quelles améliorations apporteriez-vous à notre service ? Saisissez vos commentaires ici.',
      feedbackbutton: 'Donnez-nous votre avis !',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: 'Message personnel',
    },

    closed: {
      title: 'L\'entretien est terminé ou clos',
      description: 'L\'entretien vidéo auquel vous avez été convié(e) est déjà clos ou vous avez terminé votre candidature.',
      publicTitle: 'Interview has ended',
      publicDescription: 'The video interview has already ended.',
    },
    saved: {
      title: 'Votre entretien vidéo est maintenant sauvegardé !',
      description: 'Si vous souhaitez reprendre l\'entretien vidéo, cliquez sur le lien reçu précédemment par e-mail. Vos réponses vidéo déjà enregistrées seront disponibles à votre retour ! Bon courage dans votre recherche d\'emploi !',
      remember: 'N\'oubliez pas d\'envoyer les réponses au recruteur une fois l\'entretien terminé.',
      deleteHistory: 'Si vous enregistrez un entretien vidéo depuis un ordinateur public, n\'oubliez pas d\'effacer votre historique de navigation. Ainsi, votre entretien restera entièrement confidentiel.',
    },
    unpublished: {
      title: 'L\'entretien n\'est pas encore ouvert',
      publishTime: publishTime => `L'entretien sera ouvert à ${publishTime}`,
    },
  },
}
